import { InboxAddress } from '../../components/InboxAddress';
import { INBOX_LANE_ADDRESSES } from '../../../../shared/inbox-address';
import { getCoupleCode } from '../../lib/api';
import { InboxList } from '../RoutingRules/InboxList';
import { Tooltip } from '../../ui/Tooltip';
import '../RoutingRules/routing-rules.css';

/**
 * Life → Inbox (card tlwgXSkiimS2, renamed from 'Admin' by card NWmSqIsojQyU):
 * the couple's inbox as a sub-tab, so the mail Pear took in sits beside
 * Requests and Chores instead of behind a More menu screen. Rows come from
 * GET /api/inbox through the shared InboxList — the same fetch and the same
 * rendering the routing-rules view uses, so both surfaces print the
 * classification and routing reason verbatim.
 *
 * Card zGRWc1QsfM3e (Jonathan email 2026-10-25, "move overview to
 * tooltips/help"): the lede line and the four-item "How your inbox works"
 * explainer used to sit above the list as prose. The us@ / me@ model is an
 * in-context explanation, so it now lives in the (?) tooltip beside the
 * heading and in Help (web/src/lib/help.ts, life-admin) — the same pattern
 * Requests ships (ifd8sEdMo0JA). The addresses stay on screen in the
 * InboxAddress block below, which is where you copy them from.
 *
 * Only the ingest half (SES → triage) is still waiting on the couple-inbox
 * address (card 17XyniccuSCt / UAR QMvkINMTIyNT). This tab reads whatever has
 * already been ingested — the manual ingest route and the probe's — so it is
 * live data the moment mail lands.
 */

/** The us@ / me@ model in one breath — what the explainer block used to say. */
const INBOX_OVERVIEW =
  `${INBOX_LANE_ADDRESSES.us} is your shared inbox — a bill or booking mailed there lands with you both. ` +
  `${INBOX_LANE_ADDRESSES.me} is private — mail sent there stays with whoever sent it and your partner never sees it. ` +
  'The concierge gives each message a class and says on the row why it went where it went. ' +
  'Landed wrong? Send it to moves that message and remembers the sender, so their next one follows; ' +
  'your choice beats the class and the address, and private mail never moves.';

export function Inbox({ members }: { members: { memberId: string; displayName: string }[] }) {
  return (
    <section className="rr life-admin" aria-labelledby="life-admin-title" id="life-admin-panel">
      <h2
        className="rr-title"
        id="life-admin-title"
        style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}
      >
        Inbox
        <Tooltip label={INBOX_OVERVIEW}>
          <span className="pear-tip-trigger" data-tip-for="inbox" title={INBOX_OVERVIEW}>
            ⓘ
          </span>
        </Tooltip>
      </h2>
      {/* The couple's shared inbox address (card qntf9Qa0Cemr) — where to
          email so Pear can take it in. Built from the server-issued code. */}
      <InboxAddress
        code={getCoupleCode()}
        idPrefix="admin"
        variant="inline"
        note="Email bills, bookings and receipts here — the concierge sorts each one into your shared space."
      />
      <InboxList members={members} listId="life-inbox-list" />
    </section>
  );
}
